<div class="grid-container-parent">
  <div class="grid-buttons">
    <app-database-grid-controls
      (columnListChanged)="updateColumnList($event)"
      (periodChanged)="updatePeriodSettings($event)"
      (dataSettingsChanges)="updateDataSettings($event)"
      (defaultSettingsApplied)="setDefaultGridSettings($event)"
      (indicationBreakoutChanged)="indicationBreakoutChanged($event)"
      [indicationBreakout]="indicationBreakout"
      [fullExportFlag]="fullExport"
      (showNIBChanged)="showNIBChanged($event)"
      [showNIB]="showNIB"
      [showNIBControl]="showNIBControl"
      [indicationBreakoutContol]="indicationBreakoutContol"
      [totalCount]="totalCount"
      [consolidatedCount]="consolidatedTotal"
    >
    </app-database-grid-controls>
  </div>
  <div class="grid-table">
    <app-database-grid
      [gridSettings]="gridSettings"
      [indicationBreakout]="indicationBreakout"
      (showNIBChanged)="showNIBChanged($event)"
      [showNIB]="showNIB"
      (fullExportFlagChanged)="onFullExportFlagChange($event)"
      (totalCountChanged)="onTotalCountChange($event)"
      (consolidatedCountChanged)="onConsolidatedCountChanged($event)"
    ></app-database-grid>
  </div>
</div>
